import type { SvgIconProps } from '@mui/material';
import { FinancialClosingIconSvg } from './FinancialClosingIconSvg';

type FinancialClosingIconProps = SvgIconProps;

export const FinancialClosingIcon = (props: FinancialClosingIconProps) => {
  return (
    <FinancialClosingIconSvg
      {...props}
      sx={{
        fontSize: '20px',
      }}
    />
  );
};
